export const expiredAgreementMessage = (error) => {
	const data = error && error.response && error.response.data;
	if (data && typeof data === 'object' && typeof data.message === 'string' && data.message.trim()) return data.message;
	if (typeof data === 'string') {
		try {
			const parsed = JSON.parse(data);
			if (parsed && typeof parsed.message === 'string' && parsed.message.trim()) return parsed.message;
		} catch {
			const match = data.match(/<message>([\s\S]*?)<\/message>/i);
			if (match && match[1]) {
				const textarea = document.createElement('textarea');
				textarea.innerHTML = match[1];
				if (textarea.value.trim()) return textarea.value;
			}
		}
	}
	return 'Document has expired';
};
